import {useEffect, useRef} from "react";

/**
 * Fires when the supplied state value changes
 * @param state The value to watch
 * @param callback The callback that is fired when the state value has changed
 * @param runInitially When set to true, the callback will also be fired on the first render
 */
export function useWatcher<T>(state: T, callback: (state: T, prev: T) => void, runInitially?: boolean) {
    const prevState = useRef<T>(state);

    useEffect(() => {
        if (prevState.current !== state) {
            callback(state, prevState.current);
            prevState.current = state;
        }
    }, [state, callback]);

    useEffect(() => {
        if (runInitially === true) {
            callback(state, prevState.current);
        }
    });
}